// Single source of truth for "may we track?". Cookiebot's live object wins only once
// `hasResponse` is true — window.Cookiebot exists earlier with every consent field
// seeded false, so before that the CookieConsent cookie is the only truthful source.
export const hasMarketingConsent = () => {
  if (window.Cookiebot?.hasResponse)
    return window.Cookiebot.consent?.marketing ?? false;
  return getParsedCookieConsent()?.marketing ?? false;
};

export const hasStatisticsConsent = () => {
  if (window.Cookiebot?.hasResponse)
    return window.Cookiebot.consent?.statistics ?? false;
  return getParsedCookieConsent()?.statistics ?? false;
};

const getParsedCookieConsent = (): Record<string, boolean> | null => {
  const raw = document.cookie
    .split("; ")
    .find((row) => row.startsWith("CookieConsent="));

  if (!raw) return null;

  try {
    // Split on the FIRST '=' only: the value carries a base64 `stamp` whose '=='
    // padding made split("=")[1] truncate everything after it, so every category
    // parsed false.
    const value = decodeURIComponent(raw.slice(raw.indexOf("=") + 1));

    // Bare `-1` is Cookiebot's out-of-region marker (consent not required) → allowed.
    if (value === "-1")
      return {
        necessary: true,
        preferences: true,
        statistics: true,
        marketing: true,
      };

    return value
      .replace(/^{|}$/g, "")
      .split(",")
      .reduce((acc: Record<string, boolean>, pair) => {
        const [key, val] = pair.split(":");
        acc[key.replace(/'/g, "").replace(/%27/g, "")] = val === "true";
        return acc;
      }, {});
  } catch {
    return null;
  }
};
